import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss']
})
export class ReadMoreComponent implements OnChanges {

  @Input() content: string;
  @Input() maxLength = 100;
  currentText: string;
  hideToggle = true;
  isCollapsed = true;

  constructor() { }

  toggleView() {
    this.isCollapsed = !this.isCollapsed;
    this.determineView();
  }

  determineView() {
    if (this.content) {
      if (this.content.split(' ').length <= this.maxLength) {
        this.currentText = this.content;
        this.isCollapsed = false;
        this.hideToggle = true;
      } else {
        this.hideToggle = false;
        if (this.isCollapsed === true) {
          this.currentText = this.content.replace(/\s+/g, ' ').split(/(?=\s)/gi).slice(0, this.maxLength).join('') + ' ...';
        } else if (this.isCollapsed === false) {
          this.currentText = this.content;
        }
      }
    }

  }
  ngOnChanges() {
    this.determineView();
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/read-more/read-more.component.ts